import { RoleGuid } from "./role.model";

export enum AccountUserTypeGuid {
	LimitedUser = "3b651828-db76-4e97-90fe-a1d6fb67fe26",
	ReviewUser = "44f7f2e8-075b-4607-97fb-2c1dd07d9444",
	ReadOnlyUser = "0e831830-46f4-4095-bd72-2b873d7e7c59",
	StandardUser = "9a0097d3-968f-4ab4-953e-89c817794d86",
	StandardUserPlusAddAndDeleteDoc = "9d10e0cf-d3c1-4e22-ad1c-bf38febbf065",
	PowerUser = "41077215-a97d-4269-8005-cbcdc94f32bd",
	AccountAdminUser = "61eed526-0344-4ab2-9992-4ce97249ce13",
	Custom = "df08a333-ca25-4b48-8126-abdb2f5b41b3"
}

export class AccountUserType {
	guid: AccountUserTypeGuid;
	name: string;
}

export class AccountUserTypes {
	limitedUser: AccountUserType = {
		guid: AccountUserTypeGuid.LimitedUser,
		name: "Limited User"
	};

	reviewUser: AccountUserType = {
		guid: AccountUserTypeGuid.ReviewUser,
		name: "Review User"
	};

	readOnlyUser: AccountUserType = {
		guid: AccountUserTypeGuid.ReadOnlyUser,
		name: "Read-Only User"
	};

	standardUser: AccountUserType = {
		guid: AccountUserTypeGuid.StandardUser,
		name: "Standard User"
	};

	standardUserPlusAddAndDeleteDoc: AccountUserType = {
		guid: AccountUserTypeGuid.StandardUserPlusAddAndDeleteDoc,
		name: "Standard User plus Add and Delete Doc"
	};

	powerUser: AccountUserType = {
		guid: AccountUserTypeGuid.PowerUser,
		name: "Power User"
	};

	accountAdminUser: AccountUserType = {
		guid: AccountUserTypeGuid.AccountAdminUser,
		name: "Account Admin User"
	};

	custom: AccountUserType = {
		guid: AccountUserTypeGuid.Custom,
		name: "Custom"
	};

	lookup: Record<AccountUserTypeGuid, AccountUserType> = {
		[AccountUserTypeGuid.AccountAdminUser]: this.accountAdminUser,
		[AccountUserTypeGuid.LimitedUser]: this.limitedUser,
		[AccountUserTypeGuid.ReadOnlyUser]: this.readOnlyUser,
		[AccountUserTypeGuid.ReviewUser]: this.reviewUser,
		[AccountUserTypeGuid.StandardUser]: this.standardUser,
		[AccountUserTypeGuid.StandardUserPlusAddAndDeleteDoc]: this.standardUserPlusAddAndDeleteDoc,
		[AccountUserTypeGuid.PowerUser]: this.powerUser,
		[AccountUserTypeGuid.Custom]: this.custom
	}

	lookupRoles: Record<AccountUserTypeGuid, RoleGuid[]> = {
		[AccountUserTypeGuid.LimitedUser]: [RoleGuid.LimitedFeatureSet],
		[AccountUserTypeGuid.ReviewUser]: [RoleGuid.DocReviewFeatureSet],
		[AccountUserTypeGuid.ReadOnlyUser]: [RoleGuid.StandardFeatureSet],
		[AccountUserTypeGuid.StandardUser]: [RoleGuid.StandardFeatureSet, RoleGuid.EditFeatureSet],
		[AccountUserTypeGuid.StandardUserPlusAddAndDeleteDoc]: [RoleGuid.StandardFeatureSet, RoleGuid.EditFeatureSet, RoleGuid.DeleteDocFeatureSet],
		[AccountUserTypeGuid.PowerUser]: [RoleGuid.StandardFeatureSet, RoleGuid.EditFeatureSet, RoleGuid.DeleteDocFeatureSet, RoleGuid.PowerUploadFeatureSet, RoleGuid.EditMetadataFeatureSet, RoleGuid.ManageCustomDocFieldsFeatureSet],
		[AccountUserTypeGuid.AccountAdminUser]: [RoleGuid.StandardFeatureSet, RoleGuid.EditFeatureSet, RoleGuid.DeleteDocFeatureSet, RoleGuid.PowerUploadFeatureSet, RoleGuid.EditMetadataFeatureSet, RoleGuid.ManageCustomDocFieldsFeatureSet, RoleGuid.AccountFeatureSet, RoleGuid.AuditDocFeatureSet],
		[AccountUserTypeGuid.Custom]: []
	}

	all: AccountUserType[] = [this.limitedUser, this.reviewUser, this.readOnlyUser, this.standardUser, this.standardUserPlusAddAndDeleteDoc, this.powerUser, this.accountAdminUser];

	byString(guid: string): AccountUserType {
		return this.lookup[guid];
	}
}
